import React, { Component } from 'react'
import update from 'react/lib/update';
import PropTypes from 'prop-types'
import Radium from 'radium';
import Row from './table/row'
import Cell from './table/cell'
import Header from './table/header'
import { semanticColors } from '../../../../Globals/styles';

const propTypes = {}

const defaultProps = {}

class Materiel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            width: [
                '5%',
                '55%',
                '10%',
                '10%',
                '10%',
                '10%',
            ],
            visible: '',
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.visible !== nextState.visible) { return true }
        if (this.props.materielsKey === nextProps.materielsKey) { return false }
        return true
    }
    renderHeader = () => {
        return (
            <Row
            >
                <Header
                    content={'Pos.'}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Art'}
                    style={{ width: this.state.width[1] }}
                />
                <Header
                    content={'Antal'}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Enhed'}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{ textAlign: 'center' }}
                />
                <Header
                    content={'Pris'}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Sum'}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        textAlign: 'right',
                        paddingRight: 5,
                    }}
                />
            </Row>
        )
    }
    updateFunction = (key, value, index, r) => {
        if (key == 'price') { value = value.toString().replace('.', ',') }
        r[key] = value
        this.props.update(r, index)
    }
    parseAndCalcSum(one, two) {
        return (parseFloat(one.toString().replace(',', '.')) * parseFloat(two.toString().replace(',', '.')))
    }
    renderContent = (r, index, background, tot) => {
        const materielInfo = this.props.materiels[r.id]
        let sum = this.parseAndCalcSum(r.amount, r.price)
        tot(sum)
        return (
            <Row
                key={r.id}
            >
                <Cell
                    onChange={(value) => this.updateFunction('pos', value, index, r)}
                    content={r.pos}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    content={r.name}
                    onChange={(value) => this.updateFunction('name', value, index, r)}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        backgroundColor: background
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('amount', value, index, r)}
                    content={r.amount}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',

                    }}
                />
                <Cell
                    content={r.unit}
                    onChange={(value) => this.updateFunction('unit', value, index, r)}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                {this.state.visible === r.id && !this.props.noPopup ?
                    <div style={{
                        position: 'absolute',
                        backgroundColor: semanticColors.infoLight,
                        color: 'white',
                        width: 100,
                        zIndex: 1000,
                        textAlign: 'center',
                        left: '70%',
                        boxShadow: '2px 2px 2px #888888'
                    }}>
                        <i className="fa fa-chevron-right" style={{ position: 'absolute', top: 10, right: 2 }} aria-hidden="true"></i>
                        <div style={{ paddingTop: 3 }}>
                            <div>
                                Standard
                            </div>
                            <div>
                                {materielInfo.price}
                            </div>
                            {this.props.productDiscounts[r.id] ? (
                                <div>
                                    <div>
                                        Særpris
                                </div>
                                    <div>
                                        {this.props.productDiscounts[r.id].discount}
                                    </div>
                                </div>
                            ) :
                                null}
                        </div>
                    </div>
                    :
                    null
                }
                <Cell
                    onChange={(value) => this.updateFunction('price', value, index, r)}
                    content={r.price}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                    onFocus={() => this.setState({ visible: r.id })}
                    onFocusOut={() => this.setState({ visible: 'dummyId' })}

                />
                <Cell
                    key={r.name + index + sum}
                    readOnly
                    content={sum ?
                        (Math.round(sum * 100) / 100).toString().replace('.', ',')
                        :
                        '-'}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'right',
                        paddingRight: 5,
                    }}
                />
            </Row >
        )
    }
    render() {
        let total = 0
        let count = -1
        const m = this.props.rows.map((r, index) => {
            if (r.type == this.props.type) {
                count += 1
                let background = count % 2 == 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
                return this.renderContent(r, count, background, (e) => { total += e })
            }
        })

        return (
            <div style={[{ width: '100%', }]}>
                {this.renderHeader()}
                {m}
                <div style={{ float: 'right', padding: 5, borderBottom: '1px solid ' + semanticColors.primaryLight }}>
                    <div style={{ fontWeight: 600 }}>
                        I alt: {(Math.round(total * 100) / 100).toString().replace('.', ',')}
                    </div>
                </div>
            </div>
        )
    }
}

const styles = {
    flexify: {
        display: 'flex',
        flexDirection: 'row',
    },
    column: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    }
}

Materiel.propTypes = propTypes

Materiel.defaultProps = defaultProps

export default Radium(Materiel)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Invoice/spreadsheets/materiel.js